import React from "react";
import { Box, Flex, Tooltip } from "@chakra-ui/react";
import { IconType } from "react-icons";

import { Icon } from "components/Icon";

import { FlexProps } from "@chakra-ui/layout/dist/types/flex";

interface IProps extends FlexProps {
  icon: IconType;
  tooltipLabel?: string;
}

const DetailFrame = ({
  icon,
  children,
  tooltipLabel,
  ...restProps
}: IProps) => {
  return (
    <Flex
      width={{ base: "280px", md: "350px" }}
      p={2}
      border="solid 1px gray"
      borderRadius={15}
      minH={{ base: "45px", md: "60px" }}
      alignItems="center"
      fontWeight="bold"
      {...restProps}
    >
      <Tooltip
        aria-label={tooltipLabel}
        label={tooltipLabel}
        shouldWrapChildren
      >
        <Icon
          icon={icon}
          w={{ base: 6, md: 10 }}
          h={{ base: 6, md: 10 }}
          mr={2}
        />
      </Tooltip>
      <Box maxW={{ base: "280px", md: "400px" }} m="auto">
        {children}
      </Box>
    </Flex>
  );
};

export { DetailFrame };
